import { useState } from 'react';
import { categories } from '@/mocks/categories';

export default function Footer() {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);

  const handleNewsletterSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!email || submitted) return;
    const formData = new URLSearchParams({ email }).toString();
    try {
      await fetch('https://readdy.ai/api/form/d8skvhgn4gr6p3b2gpe0', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: formData,
      });
    } catch (_) {
      // silently handle
    }
    setSubmitted(true);
    setEmail('');
  };

  return (
    <footer className="bg-primary-800 text-background-50">
      <div className="w-full px-6 md:px-10 py-16 md:py-20">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-10">
          <div>
            <a href="/" className="flex items-center gap-2 mb-4">
              <span className="w-7 h-7 flex items-center justify-center">
                <i className="ri-leaf-line text-primary-200 text-xl"></i>
              </span>
              <span className="font-heading text-lg font-bold text-background-50">Mulebuy Spreadsheet</span>
            </a>
            <p className="text-sm text-foreground-300/70 leading-relaxed max-w-xs">
              Your trusted guide to smarter cross-border shopping. We help global buyers navigate product sourcing with clarity and confidence.
            </p>
          </div>

          <div>
            <h4 className="text-xs font-semibold tracking-widest uppercase text-foreground-300/50 mb-5 font-label">Categories</h4>
            <div className="flex flex-col gap-2">
              {categories.slice(0, 6).map((cat) => (
                <a
                  key={cat.name}
                  href={cat.url}
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-sm text-background-50/80 hover:text-background-50 transition-colors duration-200 cursor-pointer"
                >
                  {cat.name}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-xs font-semibold tracking-widest uppercase text-foreground-300/50 mb-5 font-label">Quick Links</h4>
            <div className="flex flex-col gap-2">
              <a href="/" className="text-sm text-background-50/80 hover:text-background-50 transition-colors duration-200 cursor-pointer">
                Home
              </a>
              <a href="/what-is-mulebuy-spreadsheet" className="text-sm text-background-50/80 hover:text-background-50 transition-colors duration-200 cursor-pointer">
                What is Mulebuy Spreadsheet
              </a>
              <a href="https://kaspreadsheet.com/" target="_blank" rel="noopener nofollow" className="text-sm text-background-50/80 hover:text-background-50 transition-colors duration-200 cursor-pointer">
                Official Platform
              </a>
              <a href="https://kaspreadsheet.com/" target="_blank" rel="noopener nofollow" className="text-sm text-background-50/80 hover:text-background-50 transition-colors duration-200 cursor-pointer">
                Buy It Now
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-xs font-semibold tracking-widest uppercase text-foreground-300/50 mb-5 font-label">Stay Updated</h4>
            <form onSubmit={handleNewsletterSubmit} data-readdy-form="">
              <div className="flex items-end gap-0 border-b border-primary-300/30 pb-2">
                <input
                  type="email"
                  name="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Your email address"
                  required
                  className="bg-transparent text-sm text-background-50 placeholder:text-foreground-300/40 outline-none flex-1 py-1"
                />
                <button
                  type="submit"
                  className="w-8 h-8 flex items-center justify-center rounded-full bg-background-50/15 hover:bg-background-50/25 transition-colors duration-200 cursor-pointer flex-shrink-0"
                >
                  <i className="ri-arrow-right-line text-background-50 text-sm"></i>
                </button>
              </div>
              {submitted && (
                <p className="text-xs text-primary-200 mt-2">Thanks for subscribing!</p>
              )}
              <p className="text-xs text-foreground-300/40 mt-2 leading-relaxed">
                No spam, unsubscribe anytime.
              </p>
            </form>
          </div>
        </div>

        <div className="mt-16 md:mt-20 pt-8 border-t border-primary-300/15">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-foreground-300/40">
              &copy; {new Date().getFullYear()} Mulebuy Spreadsheet. All rights reserved. This is an informational guide website.
            </p>
            <div className="flex items-center gap-5">
              <a href="/" className="text-xs text-foreground-300/40 hover:text-background-50/70 transition-colors duration-200">Privacy</a>
              <a href="/" className="text-xs text-foreground-300/40 hover:text-background-50/70 transition-colors duration-200">Terms</a>
              <a href="/" className="text-xs text-foreground-300/40 hover:text-background-50/70 transition-colors duration-200">Contact</a>
            </div>
          </div>
        </div>

        <div className="mt-12 text-center">
          <span className="font-heading text-[12vw] md:text-[10vw] font-black text-primary-300/10 tracking-tight select-none leading-none">
            MULEBUY
          </span>
        </div>
      </div>
    </footer>
  );
}